/* ============================================================
   GlowNest — Apple-style scroll motion
   Adds .gn-reveal via JS only (no-JS never hides content),
   reveals on scroll, frosts the header after scrolling.
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* 1. Tag reveal targets */
    var sections = document.querySelectorAll('main .shopify-section');
    sections.forEach(function (sec) {
      var blocks = sec.querySelectorAll(':scope > div, :scope > section');
      var targets = blocks.length ? blocks : [sec];
      targets.forEach(function (el) { el.classList.add('gn-reveal'); });
    });

    /* Stagger product cards */
    document.querySelectorAll('.product-card').forEach(function (card, i) {
      card.classList.add('gn-reveal');
      var d = i % 6;
      if (d) card.setAttribute('data-gn-delay', String(d));
    });

    /* 2. Reveal on scroll */
    function showAll() {
      document.querySelectorAll('.gn-reveal').forEach(function (el) {
        el.classList.add('gn-visible');
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('gn-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
      document.querySelectorAll('.gn-reveal').forEach(function (el) { io.observe(el); });
    } else {
      showAll();
    }

    /* 3. Frosted header on scroll */
    var ticking = false;
    function onScroll() {
      document.body.classList.toggle('gn-scrolled', window.scrollY > 16);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    onScroll();
  });
})();
